module.exports = __webpack_public_path__ + "img/CECA_Myofibroblasts.5fb3c4b8.png";